import { HStack } from '@/components/ui/hstack'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { setTradeDuration, setTradePaidStatus } from '@/redux/slices/tradeSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import TradeFilterChip from './TradeFilterChip'
import {
  DURATION_OPTIONS,
  formatAmount,
  formatConversionRate,
  formatPlainAmount,
  PAID_STATUS_OPTIONS,
} from './tradeFormat'

export default function TradeOrdersHeader() {
  const dispatch = useAppDispatch()
  const stats = useAppSelector(state => state.trade.stats)
  const duration = useAppSelector(state => state.trade.duration)
  const paidStatus = useAppSelector(state => state.trade.paidStatus)
  const [greenColor] = usePlatformColor('systemGreen')

  const [amountInteger, amountDecimal] = stats ? formatAmount(stats.transactionsAmount).split('.') : ['¥-', '']

  return (
    <VStack space="md" className="px-4 pt-1 pb-3">
      <HStack space="sm">
        <TradeFilterChip
          options={DURATION_OPTIONS}
          value={duration}
          onChange={value => dispatch(setTradeDuration(value))}
        />
        <TradeFilterChip
          options={PAID_STATUS_OPTIONS}
          value={paidStatus}
          onChange={value => dispatch(setTradePaidStatus(value))}
        />
      </HStack>
      {/* Inset to the order rows' edges (px-2 + p-4 in TradeOrders), which line up with the Jiri bar */}
      <VStack space="md" className="bg-secondary-system-background rounded-2xl p-4 mx-2">
        <VStack>
          <Text size="subhead" className="text-secondary-label">
            交易额
          </Text>
          <HStack className="items-baseline justify-between">
            <Text className="text-label text-title-1 font-bold">
              {amountInteger}
              {amountDecimal ? <Text className="text-label text-title-3 font-bold">.{amountDecimal}</Text> : null}
            </Text>
            {stats && (
              <Text size="subhead" className="font-medium" style={{ color: greenColor }}>
                今日 +{formatPlainAmount(stats.todayAmount)}
              </Text>
            )}
          </HStack>
        </VStack>
        <HStack>
          <StatsColumn label="订单" value={stats?.ordersCount} align="start" />
          <StatsColumn label="成交" value={stats?.transactionsCount} align="center" />
          <StatsColumn
            label="转化率"
            value={stats ? formatConversionRate(stats.transactionsCount, stats.ordersCount) : undefined}
            align="end"
          />
        </HStack>
      </VStack>
    </VStack>
  )
}

function StatsColumn({
  label,
  value,
  align,
}: {
  label: string
  value: string | number | undefined
  align: 'start' | 'center' | 'end'
}) {
  const alignClass = { start: 'items-start', center: 'items-center', end: 'items-end' }[align]
  return (
    <VStack className={`flex-1 ${alignClass}`}>
      <Text size="subhead" className="text-secondary-label">
        {label}
      </Text>
      <Text size="subhead" className="text-label font-semibold">
        {value ?? '-'}
      </Text>
    </VStack>
  )
}
